import { httpClient } from "../http/httpClient";
import { UserRoleEnum } from "../usersService/user";

export interface SignInParams {
  email?: string;
  cpf?: string;
  password: string;
}

interface SignInResponse {
  accessToken: string;
  user: {
    _id: string;
    name: string;
    role: UserRoleEnum;
  };
}

export async function signin(params: SignInParams) {
  const { data } = await httpClient.post<SignInResponse>("/auth/login", {
    ...params,
    plataform: "WEB",
  });

  return data;
}

export const UNICO_VALIDATION_REQUIRED = "UNICO_VALIDATION_REQUIRED";

export const isUnicoValidationRequired = (error: any): boolean =>
  error?.response?.data?.message?.code === UNICO_VALIDATION_REQUIRED;

export const getUnicoValidationUserId = (error: any): string | undefined =>
  error?.response?.data?.message?.ref;
